import { useId } from 'react';

type BrandMarkProps = {
  className?: string;
  decorative?: boolean;
  mono?: boolean;
};

export function BrandMark({ className, decorative = false, mono = false }: BrandMarkProps) {
  const gradientId = useId();

  return (
    <svg
      className={className}
      viewBox="0 0 96 80"
      role={decorative ? undefined : 'img'}
      aria-hidden={decorative || undefined}
      aria-label={decorative ? undefined : 'Sticket'}
      focusable="false"
    >
      {mono ? null : (
        <defs>
          <linearGradient id={gradientId} x1="0" y1="0" x2="1" y2="1">
            <stop offset="0" stopColor="var(--brand-cyan)" />
            <stop offset="0.52" stopColor="var(--accent)" />
            <stop offset="1" stopColor="var(--brand-pink)" />
          </linearGradient>
        </defs>
      )}
      <g fill={mono ? 'currentColor' : `url(#${gradientId})`}>
        <rect x="7" y="12" width="64" height="26" rx="7" transform="rotate(32 39 25)" />
        <rect x="25" y="42" width="64" height="26" rx="7" transform="rotate(32 57 55)" />
      </g>
    </svg>
  );
}

type LiteralBrandMarkProps = {
  className?: string;
  priority?: boolean;
};

export function LiteralBrandMark({ className, priority = false }: LiteralBrandMarkProps) {
  return (
    <picture className={className} aria-hidden="true">
      <source srcSet="/brand/sticket-mark-512.webp" type="image/webp" />
      <img
        src="/brand/sticket-mark-512.png"
        alt=""
        width="512"
        height="512"
        loading={priority ? 'eager' : 'lazy'}
        fetchPriority={priority ? 'high' : 'auto'}
        decoding="async"
      />
    </picture>
  );
}

export function Wordmark() {
  return (
    <span className="wordmark" aria-label="Sticket">
      sticket
    </span>
  );
}
